import type { FaireProductEntity } from "../../entity_types/product";

export const p_y292sn6s37: FaireProductEntity = {
  token: "p_y292sn6s37",
  type: "product",
  name: "100 Things I Love About Mom Prompted Journal",
  brandToken: "b_dfu92850",
  brandName: "Pippi Post",
  imageUrl:
    "https://cdn.faire.com/fastly/22cc1057afc6a0091a332d4689472e74905b69137b2c9fff452f84738a35083c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8bb08ec3bb79843d445a0e7f60f15703081059eec67654376a178ddc87b35779.jpeg",
    "https://cdn.faire.com/fastly/7cae9d8958f26baeaa59e85b24eff2f89bb94a13fbb56b3b8eb681fa36c74c0d.jpeg",
    "https://cdn.faire.com/fastly/a6c9d1540afbbb513e0fef778062db66333eaf822b3787edd8a35c98ebebcbdd.jpeg",
    "https://cdn.faire.com/fastly/a4bee24606d111a32e4061579c8e15959237f5e2b0ec1807bad42640654cfe58.jpeg",
  ],
  priceDollars: 8.22,
  description:
    'The 100 Things I Love About Mom prompted journal is a beautiful way to tell Mom just how special she is. With 100 heartfelt, funny, and meaningful prompts, this guided journal helps you celebrate your bond through shared memories, life lessons, and all the little things that make her one-of-a-kind. Whether you fill it out for Mother’s Day, her birthday, or a just-because moment, this keepsake becomes a treasure she’ll hold close forever. Its 4x6” paperback format makes it easy to complete in a weekend or slowly over time. A perfect gift for the mom who does it all, this journal is a sweet reminder of how deeply she’s loved.\n\nFeatures: Paperback cover, 52 pages\nSize: 4×6"',
  tags: [],
  msrpDollars: 16.44,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:54.478Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
